class occupation_arr {
  static value = [{
    value: '0',
    label: '未定义'
  }, {
    value: '11',
    label: '国家公务员'
  }, {
    value: '13',
    label: '专业技术人员'
  }, {
    value: '17',
    label: '职员'
  }, {
    value: '21',
    label: '企业管理人员'
  }, {
    value: '24',
    label: '工人'
  }, {
    value: '27',
    label: '农民'
  }, {
    value: '31',
    label: '学生'
  }, {
    value: '37',
    label: '现役军人 '
  }, {
    value: '51',
    label: '自由职业者 '
  }, {
    value: '54',
    label: '个体经营者  '
  }, {
    value: '70',
    label: '无业人员 '
  }, {
    value: '80',
    label: '退离休人员 '
  }, {
    value: '90',
    label: '其他 '
  }]
}
class card_type_arr {
  static value =[{
    value: '身份证',
    label: '身份证'
  }]
}
class options {
  static value =[{
    value: '岁',
    label: '岁'
  }, {
    value: '月',
    label: '月'
  }, {
    value: '周',
    label: '周'
  }, {
    value: '天',
    label: '天'
  }]
}
class imgURL {
  static value = 'http://view.test.rimag.com.cn/?url=/rimag.json&studyUid='
}
export default {
  occupation_arr,
  card_type_arr,
  options,
  imgURL
}
